import styled from 'styled-components';

const Stack = styled.div`
    ${({
        theme,
        $space = '0px',
        $direction = 'column',
        $inline = false,
        $wrap = true,
    }) => {
        const marginProperty = $direction === 'row' ? 'right' : 'bottom';
        const marginAttribute =
            typeof $space === 'function' ? $space(theme) : $space;
        const displayPropertySuffix = $direction === 'row' ? 'flex' : 'block';
        const displayProperty = $inline
            ? `inline-${displayPropertySuffix}`
            : displayPropertySuffix;

        return `
            display: ${displayProperty};
            flex-wrap: ${$wrap ? 'wrap' : 'nowrap'};

            & > * {
                margin-${marginProperty}: ${marginAttribute};
            }

            & > :last-child {
                margin-${marginProperty}: 0;
            }
        `;
    }}
`;

export default Stack;
